import { Component } from '@angular/core';
import { SurveyService } from '../../Services/survey.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberSurvey, Ratings } from '../../AllTableClasses';
import { PopupNotificationService } from '../../Services/popup-notification.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.scss'
})
export class SurveyComponent {

  public survey: MemberSurvey = new MemberSurvey();
  public GeneratedGuid!: string;
  public Field1Ratings: Ratings = new Ratings();
  public Field2Ratings: Ratings = new Ratings();
  public Field3Ratings: Ratings = new Ratings();

  constructor(
    private surveyService: SurveyService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private popupNotificationService: PopupNotificationService


  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.GeneratedGuid = params['survey'];
    }).unsubscribe();
    if (this.GeneratedGuid == undefined || this.GeneratedGuid == null || this.GeneratedGuid == "") {
      this.RouteLogin();
    }
    else {
      this.MemberSurveyGet();
    }
  }

  public selectRating(field: Ratings, rating: number): void {
    // Highlight all ratings up to the selected one
    for (let i = 0; i < field.ratingOptions.length; i++) {
      field.ratingOptions[i] = i < rating;
    }
    field.answer = rating; // Save the selected rating
  }


  public MemberSurveyGet() {
    this.surveyService.MemberSurveyGet(this.GeneratedGuid, (data) => {
      if (data.Success) {
        this.survey = data.Data;
      }
      else {
        this.popupNotificationService.showNotifcation('error', data.UserErrorMessage);
        this.RouteLogin();
      }
    }, (error) => { });
  }

  public RouteLogin() {
    this.router.navigate(['login']);
  }

  public MemberSurveyAnswersSet(): void {
    this.survey.AnswerField1 = this.Field1Ratings?.answer.toString() || '0';
    this.survey.AnswerField2 = this.Field2Ratings?.answer.toString() || '0';
    this.survey.AnswerField3 = this.Field3Ratings?.answer.toString() || '0';

    this.surveyService.MemberSurveyAnswersSet(this.survey, (data) => {
      if (data.Success)
      {
        this.popupNotificationService.showNotifcation('success', 'Survey Successfully Submitted ');
        this.RouteLogin();
      }
      else
      {
        this.popupNotificationService.showNotifcation('error', data.UserErrorMessage);
      }
    }, (error) =>
    {
      this.popupNotificationService.showNotifcation('error', 'Error submitting survey:', error);
    });
  }
}
